import { Api, IApiResponse } from '../api';
import { UserPreferencesDto } from '../models';

export const get = (accessToken?:string): Promise<IApiResponse<UserPreferencesDto>> => Api.get('user-preferences/me', accessToken);

export const update = (userPreferences: UserPreferencesDto, accessToken?:string) => Api.put('user-preferences/me', userPreferences,undefined, accessToken);

export const reset = (accessToken?:string) => Api.delete('user-preferences/me', accessToken);
